import { render, staticRenderFns } from "./NejmEdittingClass.vue?vue&type=template&id=5ed99ed9&scoped=true"
import script from "./NejmEdittingClass.vue?vue&type=script&lang=js"
export * from "./NejmEdittingClass.vue?vue&type=script&lang=js"
import style0 from "./NejmEdittingClass.vue?vue&type=style&index=0&id=5ed99ed9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed99ed9",
  null
  
)

export default component.exports